<script lang="ts" setup></script>
<template>
  <img alt="pt language flag" height="19" loading="lazy" src="/assets/flags/pt.webp" width="19" />
</template>
